/**
* [translations description]
* @type {Object}
*/

export default {
    en: {
        "yes" : "Yes",
        "no" : "No",
        "ok" : "Ok",
    },
    id: {
        "yes" : "Ya",
        "no" : "Tidak",
        "ok" : "Oke",
    },
    th: {
        "yes" : "ใช่",
        "no" : "ไม่",
        "ok" : "ตกลง",
    },
    fil: {
        "yes" : "Oo",
        "no" : "Hindi",
        "ok" : "Ok",
    },
    ms: {
        "yes" : "Ya",
        "no" : "Tidak",
        "ok" : "Ok",
    },
    vi: {
        "yes" : "Có",
        "no" : "Không",
        "ok" : "Ok",
    }
}

    